const AddNewItemForm = ({ title, value, onChange, onSubmit }) => {
    return (
        <form onSubmit={e => onSubmit(e)} className="border border-gray-700">
            <div className="text-lg p-2 bg-gray-900">{ title }</div>
            <div className="flex p-2">
                <input type="text" className="border bg-gray-700 border-gray-700 rounded p-2 mr-2 w-full" value={value} onChange={e => onChange(e)} />
                <button className="border border-blue-700 bg-blue-800 cursor-pointer hover:bg-blue-700 hover:border-blue-800 text-white rounded p-2 flex-1">Add</button>
            </div>
        </form>
    );
}

export default AddNewItemForm;